import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageConfiguration } from '../storage-setting/storage-configuration';
import { Configuration } from "../../../app.configuration";


@Injectable({
    providedIn: 'root'
})

export class DataService {

    headers = new HttpHeaders();

    constructor(private http: HttpClient,
        private storageConfiguration: StorageConfiguration, private config: Configuration) {
    }

    // Dynamic data service

    public add<T>(apiUrl: string, itemName: any): Observable<T> {
        return this.http.post<T>(apiUrl, itemName);
    }

    public getSingle<T>(id: string, apiUrl: string): Observable<T> {
        return this.http.get<T>(apiUrl + id);
    }

    public getAll<T>(apiUrl: string): Observable<T> {
        return this.http.get<T>(apiUrl)
    }

    public getAllPlan<T>(apiUrl: string): Observable<T> {
        let header = this.headers.set('AuthenticationKey', 'SyM52ZMDrK4ZR5LCuFzkDjnMRuHDhuUO');
        return this.http.get<T>(apiUrl, { headers: header })
    }

    public delete<T>(apiUrl: string, data: any): Observable<T> {
        return this.http.put<T>(apiUrl, data);
    }

    public downloadExcelReport(date?: string): Observable<ArrayBuffer> {
        const url = `${this.config.downloadTask}/getAllEmployeeReport`;
        const params = date ? { date } : {};
        return this.http.get(url,{ params, responseType: 'arraybuffer' });
      }

      public getEmployeeReport(tenantId?: string): Observable<ArrayBuffer> {
        const url = `${this.config.downloadTask}/getERPDeteils`;
        let params = new HttpParams();
        if (tenantId) {
          params = params.set('tenantId', tenantId);
        }
        return this.http.get(url, { params, responseType: 'arraybuffer' });
      }  
}









